import css from 'styled-jsx/css';
import colors from '../../../../config/styles/colors';
import zIndex from '../../../../config/styles/zIndex';

const ImageGalleryControlButtonsStyles = css`
  .headline-control {
    position: absolute;
    top: 50%;
    height: 64px;
    width: 34px;
    background-color: rgba(255, 255, 255, 0.4);
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: ${zIndex.imageGallery.button};
    outline: none;

    &.left {
      left: 0;
      box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.2);
    }

    &.right {
      right: 0;
      box-shadow: -2px 0 5px -2px rgba(0, 0, 0, 0.2);
    }
    &.connect-button {
      height: 29px;
      width: 15px;
    }

    &.opaque {
      background-color: ${colors.black.shade6};
    }
  }

  .icon {
    color: ${colors.gray.shade34};

    &.i-gallery.csicon-arrow_right {
      margin-left: 0;
    }
  }
`;

export { ImageGalleryControlButtonsStyles };
